export const OUTREACH_TABS = [
    'callouts',
    'reminders',
    'messages',
    'scheduled',
] as const;

export type OutreachTab = (typeof OUTREACH_TABS)[number];

// Surveys are their own product area at /surveys. The old tab value still
// parses so `/outreaches?tab=surveys` bookmarks redirect instead of failing
// search validation.
export const LEGACY_SURVEYS_TAB = 'surveys';

export const OUTREACH_TAB_SEARCH_VALUES = [
    ...OUTREACH_TABS,
    LEGACY_SURVEYS_TAB,
] as const;
